import { render, staticRenderFns } from "./accueil.vue?vue&type=template&id=521da781&scoped=true"
import script from "./accueil.vue?vue&type=script&lang=js"
export * from "./accueil.vue?vue&type=script&lang=js"
import style0 from "./accueil.vue?vue&type=style&index=0&id=521da781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521da781",
  null
  
)

export default component.exports